import Service from './Service';
const resource = '/api/anamnesis-alimentaria';

const store = (data) => {
    return Service.post(`${resource}/store`, data);
}

const show = (idHistoria) => {
    return Service.get(`${resource}/show-by-idHistoria/${idHistoria}`);
}

export default {
    store,
    show
}